import { bl_fi_mst_set_of_books_hdr_RowClass } from '../../../dbschema/bl_fi_mst_set_of_books_hdr.model';
import { bl_fi_mst_set_of_books_line_RowClass } from '../../../dbschema/bl_fi_mst_set_of_books_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class SetOfBooksContainerModel extends BaseContainerModel {
  bl_fi_mst_set_of_books_hdr: bl_fi_mst_set_of_books_hdr_RowClass = new bl_fi_mst_set_of_books_hdr_RowClass();
  bl_fi_mst_set_of_books_lines: bl_fi_mst_set_of_books_line_RowClass[] = [];
}
